/* ========================================
AnnouncementCarousel
======================================== */
class AnnouncementCarousel extends HTMLElement {
    constructor() {
        super();
        this.currentSlide = 0;
        this.slides = [];
        this.intervalId = null;
        this.autoplayDelay = 5000; // 5 seconds
    }

    connectedCallback() {
        // Wait for children to be rendered
        setTimeout(() => {
            this.init();
        }, 0);
    }

    init() {
        this.slides = Array.from(this.querySelectorAll('.announcement-slide'));
        
        if (this.slides.length <= 1) {
            // Hide navigation if only one slide
            const navButtons = this.querySelectorAll('.announcement-nav');
            navButtons.forEach(btn => btn.style.display = 'none');
            return;
        }

        this.setupNavigation();
        this.startAutoplay();
    }

    disconnectedCallback() {
        this.stopAutoplay();
    }

    setupNavigation() {
        const prevBtn = this.querySelector('.announcement-prev');
        const nextBtn = this.querySelector('.announcement-next');

        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                this.previousSlide();
                this.resetAutoplay();
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                this.nextSlide();
                this.resetAutoplay();
            });
        }
    }

    nextSlide() {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        this.updateSlides();
    }

    previousSlide() {
        this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
        this.updateSlides();
    }

    updateSlides() {
        this.slides.forEach((slide, index) => {
            slide.classList.toggle('active', index === this.currentSlide);
        });
    }

    startAutoplay() {
        if (this.slides.length <= 1) return;
        
        this.stopAutoplay();
        this.intervalId = setInterval(() => {
            this.nextSlide();
        }, this.autoplayDelay);
    }

    stopAutoplay() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    resetAutoplay() {
        this.startAutoplay();
    }
}

if (!customElements.get('announcement-carousel')) {
    customElements.define('announcement-carousel', AnnouncementCarousel);
}